//
// TooltipEvent.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/events/PortableEvent";
import "./TooltipInfoController";
import "./TooltipLinksController";
import "./TooltipDrillController";
import "./TooltipSortController";
import "./TooltipMapController";
import "./TooltipOptionsController";
import "../../controllers/view/VisualController";
import "@sas-dvr/ltjs-commons/pickResults/PickResult";

var TooltipEvent = createModule("BIRD::TooltipEvent", ["commons::PortableEvent"], ClosetObject, [
    {
        HIDE: 50045,
        SHOW: 50046,
    },
    ,
    ,
    ,
    {
        getVisualController: [1],
        getLocationWithinSection: [11],
        getPickResults: [[1]],
        getTooltipSortController: [1],
        getLocationWithinVisual: [11,2],
        supportsExpandCollapse: [2],
        getTooltipMapController: [1],
        getTooltipLinksController: [1],
        getLocationOverride: [11,2],
        getTooltipDrillControllers: [[1]],
        getTooltipInfoController: [1],
        getTooltipOptionsController: [1],
    },
    ,
    ,
]);
export default TooltipEvent;
